// Define the handler class
function BannerSearch(rootEl) {
	// Store the root el
	this.rootEl = rootEl;

	// Store the last search term
	this.previousSearchTerm = '';

	// Store a controller used to abort the current search
	this.abortController = false;

	// Find sub elements
	const inputEl = rootEl.querySelector('[name="s"]');
	const buttonEl = rootEl.querySelector('button');

	// Listen for events on the input
	const inputEventTypes = ['focus', 'change', 'keydown', 'keyup'];
	inputEventTypes.forEach(function(eventType) {
		inputEl.addEventListener(eventType, this.inputUpdated.bind(this));
	}, this);

	// Update a class on the rootEl when the form gains focus
	document.addEventListener('click', this.updateBlurredModifier.bind(this));

	// Resize the results element when the window resizes (mobile form only)
	if (this.rootEl.closest('.mobile-banner-body') instanceof window.HTMLElement) {
		window.addEventListener('resize', this.updateResultsContainerHeight.bind(this), { passive: true });
	}

	const headerSearchIcon = document.getElementsByClassName('header-search-input-submit');


	if (headerSearchIcon) {

		Array.prototype.forEach.call(headerSearchIcon, function(el) {
			el.addEventListener('click', function(event) {
				if (!el.classList.contains('active')) {
					event.preventDefault();
					el.classList.add('active');
					el.previousElementSibling.classList.add('show');
					el.previousElementSibling.focus();
				}
            }.bind(this));
		});
	}
	

}

/**
 * Resize the results element when the window resizes
 */
BannerSearch.prototype.updateResultsContainerHeight = function() {
	const resultsEl = this.rootEl.querySelector('.banner-search-form__results');
	const clientRect = resultsEl.getBoundingClientRect();
	const height = window.innerHeight - clientRect.y;
	resultsEl.style.height = height + 'px';
};

/**
 * Update a class on the rootEl when the form gains focus
 * @param     { Event } event    An event raised by the user action
 * @return    void
 */
BannerSearch.prototype.updateBlurredModifier = function(event) {
	const isBlured = (
		this.rootEl !== event.target &&
		!this.rootEl.contains(event.target)
	);
	this.rootEl.classList.toggle('banner-search-form--blurred', isBlured);
};

/**
 * Toggle a class on the rootEl
 * @param     { bool } noResults    True if there are no results
 * @return    void
 */
BannerSearch.prototype.toggleNoResultsModifier = function(noResults) {
	this.rootEl.classList.toggle('banner-search-form--no-results', noResults);
};

/**
 * Check the search input and kick-off a search if valid
 * @param     { Event } event    An event raised by the user action
 * @return    void
 */
BannerSearch.prototype.inputUpdated = function(event) {
	// Get the input el
	const inputEl = event.target;

	// Abort if the value hasn't actually changed
	if (inputEl.value === this.previousSearchTerm) {
		return;
	}

	// Abort previous search
	if (this.isFetchInProgress()) {
		this.cancelFetchInProgress();
	}

	// Store the new value
	this.previousSearchTerm = inputEl.value;

	// Abort if the search term is too short
	if (3 > inputEl.value.length) {
		this.toggleNoResultsModifier(true);
		return;
	}

	// Bit of a hack to make sure the mobile results container fills the screen
	if (this.rootEl.closest('.mobile-banner-body') instanceof window.HTMLElement) {
		this.updateResultsContainerHeight();
	}

	// Perform a search and populate results
	const self = this;
	this.fetchResults(inputEl.value)
		.then(function(response) {
			return response.json();
		})
		.then(function(results) {
			self.populateResults(results, inputEl.value);
		})
		.catch(function(e) {
			self.toggleNoResultsModifier(true);
		});
};

/**
 * Populate search results
 * @param     { Object[] } results    Search result objects
 * @param     { string } keywords     The keywords used to obtain the search results
 * @return    void
 */
BannerSearch.prototype.populateResults = function(results, keywords) {
	const templateEl = this.rootEl.querySelector('.banner-search-form__results-item-template');
	const resultsEl = this.rootEl.querySelector('.banner-search-form__results');
	const existingResultItemEls = Array.from(resultsEl.querySelectorAll('.banner-search-form__results-item'));

	// Clear existing results
	existingResultItemEls.forEach(function(resultItemEl) {
		resultItemEl.remove();
	});

	//
	this.toggleNoResultsModifier(0 === results.length);

	// Construct and append new results
	const fragment = new DocumentFragment();
	results.forEach(function(result) {
		// Clone the result item template
		const cloneEl = templateEl.content.cloneNode(true);

		// Update the anchor
		const anchorEl = cloneEl.querySelector('a');
		anchorEl.textContent = result.title;
		anchorEl.setAttribute('href', result.url);

		// Highlight keywords
		anchorEl.innerHTML = this.highlightKeywordsInText(anchorEl.innerHTML, keywords);

		// Add the result item to the fragment
		fragment.appendChild(cloneEl);
	}, this);
	resultsEl.appendChild(fragment);
};

/**
 * Highlight keywords in a string
 * @param     { string } resultText        The text to search
 * @param     { string } keywordsString    Keywords to highlight
 * @return    string
 */
BannerSearch.prototype.highlightKeywordsInText = function(resultText, keywordsString) {
	// Split keywords
	const keywords = keywordsString.split(' ');

	// Search and replace each keyword
	keywords.forEach(function(keyword) {
		const regex = new RegExp('(' + keyword + ')', 'ig');
		resultText = resultText.replace(regex, '<strong>$1</strong>');
	}, this);

	// Done
	return resultText;
};

/**
 * Check if a search is currently pending
 * @return    bool
 */
BannerSearch.prototype.isFetchInProgress = function() {
	return this.abortController instanceof AbortController;
};

/**
 * Cancel any in-progress search
 * @return    void
 */
BannerSearch.prototype.cancelFetchInProgress = function() {
	if (!this.isFetchInProgress()) {
		return;
	}

	this.abortController.abort();
	this.abortController = false;
};

/**
 * Request search results from the WP REST API
 * @param     { string } keyword    The keyword to search for
 * @return    Promise<Object[]>
 */
BannerSearch.prototype.fetchResults = function(keyword) {
	//
	const url = new URL(window.rest_base_url + 'wp/v2/search');
	url.searchParams.set('search', keyword);

	//
	this.abortController = new AbortController();

	//
	return fetch(
		url.toString(),
		{
			signal: this.abortController.signal,
		}
	);
};

// Init a handler for each instance of the search form
const formEls = Array.from(document.querySelectorAll('.banner-search-form'));
formEls.forEach(function(formEl) {
	new BannerSearch(formEl);
});

